import React, { useEffect, useRef, useState } from "react";
import { Container } from "../components/utils";

const News = ({ lang, media, enPhrase, arPhrase }) => {
  const [expandedId, setExpandedId] = useState(null);
  const [croppedItems, setCroppedItems] = useState({});
  const [activeDot, setActiveDot] = useState(null);

  const trackRef = useRef(null);
  const descriptionRefs = useRef({});
  const cardRefs = useRef({});
  const leftRefs = useRef({});
  const rightRefs = useRef({});

  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);

  const isAr = lang === "ar";

  const getImageSrc = (image) => {
    if (!image) return "";

    return image?.includes("emiratesauction.com")
      ? image.replace("https://cdn.eje.ae/media/", "")
      : image;
  };

  const checkCroppedDescriptions = () => {
    const croppedMap = {};

    Object.entries(descriptionRefs.current).forEach(([id, element]) => {
      if (element) {
        croppedMap[id] = element.scrollHeight > element.clientHeight + 1;
      }
    });

    setCroppedItems(croppedMap);
  };

  const setRightPanelHeight = (id) => {
    const leftElement = leftRefs.current[id];
    const rightElement = rightRefs.current[id];

    if (!leftElement || !rightElement) return;

    rightElement.style.height = `${leftElement.offsetHeight}px`;
  };

  const resetRightPanelHeight = (id) => {
    const rightElement = rightRefs.current[id];

    if (rightElement) {
      rightElement.style.height = "";
    }
  };

  const toggleExpand = (id) => {
    setExpandedId((currentId) => {
      if (currentId === id) {
        resetRightPanelHeight(id);
        return null;
      }

      if (currentId) {
        resetRightPanelHeight(currentId);
      }

      setTimeout(() => {
        setRightPanelHeight(id);

        cardRefs.current[id]?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }, 60);

      return id;
    });
  };

  const syncDots = () => {
    const track = trackRef.current;
    if (!track) return;

    const cards = Object.entries(cardRefs.current);
    if (!cards.length) return;

    const center = track.scrollLeft + track.clientWidth / 2;

    let bestId = null;
    let bestDistance = Infinity;

    cards.forEach(([id, card]) => {
      if (!card) return;

      const distance = Math.abs(
        card.offsetLeft + card.offsetWidth / 2 - center,
      );

      if (distance < bestDistance) {
        bestDistance = distance;
        bestId = id;
      }
    });

    setActiveDot(bestId);
  };

  const scrollTrack = (direction) => {
    const track = trackRef.current;
    if (!track) return;

    track.scrollBy({
      left: isAr ? direction * -400 : direction * 400,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (!media?.length) return;

    const timer = setTimeout(() => {
      checkCroppedDescriptions();

      if (expandedId) {
        setRightPanelHeight(expandedId);
      }

      syncDots();
    }, 150);

    window.addEventListener("resize", checkCroppedDescriptions);
    window.addEventListener("resize", syncDots);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkCroppedDescriptions);
      window.removeEventListener("resize", syncDots);
    };
  }, [media, lang, expandedId]);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    track.addEventListener("scroll", syncDots, { passive: true });
    syncDots();

    return () => {
      track.removeEventListener("scroll", syncDots);
    };
  }, [media]);

  const handlePointerDown = (e) => {
    const track = trackRef.current;
    if (!track) return;

    isDraggingRef.current = true;
    startXRef.current = e.pageX - track.offsetLeft;
    scrollLeftRef.current = track.scrollLeft;

    track.setPointerCapture?.(e.pointerId);
  };

  const handlePointerMove = (e) => {
    const track = trackRef.current;
    if (!track || !isDraggingRef.current) return;

    e.preventDefault();

    const x = e.pageX - track.offsetLeft;
    const walk = x - startXRef.current;

    track.scrollLeft = scrollLeftRef.current - walk;
  };

  const handlePointerUp = (e) => {
    const track = trackRef.current;
    if (!track) return;

    isDraggingRef.current = false;
    track.releasePointerCapture?.(e.pointerId);
  };

  return (
    <section
      id="news"
      dir={isAr ? "rtl" : "ltr"}
      className=" [--card-w:82vw] [--gap:20px] min-[480px]:[--card-w:328px] px-[24px]"
    >
     <Container>
       <div className="flex flex-col lg:flex-row gap-5 items-start">
        {/* Title Card */}
        <div
          className="flex-none w-full lg:w-[312px] h-[119px] lg:h-[445px] border border-[#e6d7a2] rounded-[24px] bg-[#f9f7ed] bg-no-repeat bg-contain bg-left-bottom px-6 sm:px-8 pt-8 overflow-hidden"
          style={{ backgroundImage: "url(/assets/img/home/bgNews.svg)" }}
        >
          <h2 className="text-[28px] sm:text-[32px] lg:text-4xl font-bold text-[#361e12] leading-tight">
            {/* {lang === "en" ? "Media Center" : "المركز الإعلامي"} */}
            {lang === "en"
              ? enPhrase["lblMediaCenter"]
              : arPhrase["lblMediaCenter"]}
          </h2>
        </div>

        {/* Carousel Side */}
        <div className="relative flex-1 min-w-0 w-full">
          {/* Arrows */}
          {/* <div
            className="
              hidden
              md:flex
              absolute
              -top-14
              right-start
              -translate-x-1/2
              gap-2
              z-10
            "
          >
            <button
              type="button"
              onClick={() => scrollTrack(-1)}
              aria-label={lang === "en" ? "Previous" : "السابق"}
              className="
                w-10
                h-10
                rounded-full
                border
                border-[#e6d7a2]
                bg-[#f9f7ed]
                text-[#361e12]
                text-2xl
                leading-none
                hover:opacity-80
                flex
                items-center
                justify-center
              "
            >
              {isAr ? "‹" : "‹"}
            </button>

            <button
              type="button"
              onClick={() => scrollTrack(1)}
              aria-label={lang === "en" ? "Next" : "التالي"}
              className="
                w-10
                h-10
                rounded-full
                border
                border-[#e6d7a2]
                bg-[#f9f7ed]
                text-[#361e12]
                text-2xl
                leading-none
                hover:opacity-80
                flex
                items-center
                justify-center
              "
            >
              {isAr ? "›" : "›"}
            </button>
          </div> */}

          {/* Carousel */}
          <div
            ref={trackRef}
            role="region"
            aria-label={lang === "en" ? "News articles" : "الأخبار"}
            tabIndex={0}
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerUp={handlePointerUp}
            onPointerLeave={handlePointerUp}
            className="flex gap-[var(--gap)] overflow-x-auto scroll-smooth snap-x snap-mandatory items-start pb-4 cursor-pointer select-none touch-pan-x [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          >
            {media?.map((item, index) => {
              const id = String(item?.id || index);
              const isExpanded = expandedId === id;
              const canExpand = croppedItems[id] || isExpanded;

              return (
                <article
                  key={id}
                  ref={(el) => {
                    cardRefs.current[id] = el;
                  }}
                  className={`flex-none flex flex-row items-start overflow-hidden snap-start rounded-[24px] border border-[#e6d7a2] bg-[#f9f7ed] shadow-sm transition-[width,max-width,box-shadow,transform] duration-500 ease-in-out ${isExpanded ? "w-[calc((var(--card-w)*2)+var(--gap))] max-w-[calc((328px*2)+20px)] shadow-xl" : "w-[var(--card-w)] max-w-[328px] hover:shadow-md"}`}
                >
                  {/* Left Card */}
                  <div
                    ref={(el) => {
                      leftRefs.current[id] = el;
                    }}
                    className="
                      flex-none
                      w-[var(--card-w)]
                      max-w-[328px]
                      flex
                      flex-col
                      min-w-0
                    "
                  >
                    <div className="w-full h-[232px] overflow-hidden flex-shrink-0">
                      <img
                        src={getImageSrc(item?.image)}
                        alt={item?.title || ""}
                        loading="lazy"
                        className={`
                          w-full
                          h-full
                          object-cover
                          transition-transform
                          duration-500
                          ease-in-out
                          ${isExpanded ? "scale-[1.04]" : "hover:scale-[1.04]"}
                        `}
                      />
                    </div>

                    <div className="p-6 flex flex-col min-h-[212px]">
                      <h3
                        className="
                          text-lg
                          font-bold
                          leading-[1.55]
                          text-[#361e12]
                          mb-3
                          min-h-[56px]
                          line-clamp-2
                        "
                      >
                        {item?.title}
                      </h3>

                      <p
                        ref={(el) => {
                          descriptionRefs.current[id] = el;
                        }}
                        className="
                          text-sm
                          leading-[1.7]
                          text-[#4a4a4a]
                          mb-4
                          line-clamp-2
                        "
                      >
                        {item?.descreption}
                      </p>

                      {canExpand && (
                        <button
                          type="button"
                          onPointerDown={(e) => e.stopPropagation()}
                          onClick={() => toggleExpand(id)}
                          aria-expanded={isExpanded}
                          className="mt-auto w-fit text-sm font-bold text-[#b49b57] hover:opacity-80"
                        >
                          {isExpanded
                            ? lang === "en"
                              ? "Show Less"
                              : "عرض أقل"
                            : lang === "en"
                              ? "Read More"
                              : "اقرأ المزيد"}
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Right Expanded Panel */}
                  <div
                    ref={(el) => {
                      rightRefs.current[id] = el;
                    }}
                    aria-hidden={!isExpanded}
                    className={`
                      flex-none
                      overflow-hidden
                      border-[#e6d7a2]
                      opacity-0
                      transition-[width,opacity,border-inline-start-width]
                      duration-500
                      ease-in-out

                      ${
                        isExpanded
                          ? "w-[calc(var(--card-w)+var(--gap))] max-w-[calc(328px+20px)] opacity-100 border-s overflow-y-auto"
                          : "w-0 h-0 border-s-0"
                      }
                    `}
                  >
                    <div
                      className="
                        w-[calc(var(--card-w)+var(--gap))]
                        max-w-[calc(328px+20px)]
                        h-full
                        overflow-y-auto
                        p-6
                        [scrollbar-width:thin]
                      "
                    >
                      <span className="block text-[14px] font-bold text-[#b49b57] mb-2 capitalize">
                        {lang === "en"
                          ? enPhrase["lblDetails"]
                          : arPhrase["lblDetails"]}
                      </span>

                      <div className="text-sm leading-[1.9] text-[#361e12]">
                        {item?.descreption}
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" aria-hidden="true">
            {media?.map((item, index) => {
              const id = String(item?.id || index);

              return (
                <span
                  key={id}
                  className={`
                    w-1.5
                    h-1.5
                    rounded-full
                    transition
                    duration-150
                    ${
                      activeDot === id
                        ? "bg-[#361e12] scale-125"
                        : "bg-[#e6d7a2]"
                    }
                  `}
                />
              );
            })}
          </div>
        </div>
      </div>
     </Container>
    </section>
  );
};

export default News;
